import { useAPI, useFetchAPI } from '@/composables';
import type {
  TeamMembersResponse,
  TeamMember,
  InviteResponse
} from '@/types/team-types';

/**
 * Fetch team members
 */
export const getTeamMembers = () => {
  return useAPI<TeamMembersResponse>('/team-management/team/members');
};

/**
 * Add an existing user to the team
 *
 * @param userId - ID of the user to add
 * @param role - Role to assign to the user
 */
export const addTeamMember = (userId: number, role: string) => {
  return useFetchAPI('/team-management/team/members', {
    method: 'POST',
    body: { user_id: userId, role }
  });
};

/**
 * Invite a new user to join the team
 *
 * @param email - Email of the user to invite
 * @param role - Role to assign to the user
 * @param name - Optional name of the user
 */
export const inviteTeamMember = (
  email: string,
  role: string,
  name?: string
) => {
  const payload: Record<string, any> = { email, role };

  if (name) {
    payload.name = name;
  }

  return useFetchAPI('/team-management/team/members/invite', {
    method: 'POST',
    body: payload
  });
};

/**
 * Remove a member from the team
 *
 * @param userId - ID of the user to remove
 */
export const removeTeamMember = (userId: number) => {
  return useFetchAPI(`/team-management/team/members/${userId}`, {
    method: 'DELETE'
  });
};

/**
 * Remove a member from the team
 *
 * @param userId - ID of the user to remove
 */
export const removePendingTeamMember = (inviteId: number) => {
  return useFetchAPI(
    `/team-management/team/members/remove/invite/${inviteId}`,
    {
      method: 'DELETE'
    }
  );
};
